import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
// Website Reducers
import assets from './modules/assets';
import blogAdmin from './modules/blogAdmin';
import clientMiddleware from './modules/clientMiddleware';
import company from './modules/company';
import contact from './modules/contact';
import coupon from './modules/coupon';
import facilities from './modules/facilities';
import googleReviews from './modules/googleReviews';
import groups from './modules/groups';
import hostnames from './modules/hostnames';
import lead from './modules/lead';
import movein from './modules/movein';
import page from './modules/page';
import pages from './modules/pages';
import popup from './modules/popup';
import reservations from './modules/reservations';
import reviews from './modules/reviews';
import robots from './modules/robots';
import routes from './modules/routes';
import searchResultsUnitFilter from './modules/searchResultsUnitFilter';
import site from './modules/site';
import sms from './modules/sms';
import storageCalculator from './modules/storageCalculator';
import user from './modules/user';
// Admin Reducers
// import builder from './modules/builder';
// import certificates from './modules/certificates';
// import events from './modules/events';
// import files from './modules/files';
// import hyper from './modules/hyper';
// import pageBuilder from './modules/pageBuilder';
// import pageSettings from './modules/pageSettings';

export default combineReducers({
  assets,
  blogAdmin,
  clientMiddleware,
  company,
  contact,
  coupon,
  facilities,
  googleReviews,
  groups,
  hostnames,
  lead,
  movein,
  page,
  pages,
  popup,
  reservations,
  reviews,
  robots,
  routes,
  searchResultsUnitFilter,
  site,
  sms,
  storageCalculator,
  user,
  // builder,
  // certificates,
  // events,
  // files,
  // hyper,
  // pageBuilder,
  // pageSettings,
  form,
});
